import { explainFirebaseError, isFirebaseConfigured } from "data/firebase";
import {
  approveKadekonApplicationInFirestore,
  formatKadekonPhone,
  listKadekonApplicationsFromFirestore,
  listKadekonMembersFromFirestore,
  listKadekonQrCodesFromFirestore,
  rejectKadekonApplicationInFirestore,
  revokeKadekonQrInFirestore,
  setKadekonMemberStatusInFirestore,
} from "data/firebase/kadekonApi";

export { formatKadekonPhone };

function wrap(error, fallback) {
  const explained = explainFirebaseError(error);
  if (explained && explained !== error?.message) return new Error(explained);
  return error instanceof Error ? error : new Error(fallback);
}

export const kadekonRepo = {
  async listApplications() {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await listKadekonApplicationsFromFirestore();
    } catch (error) {
      throw wrap(error, "KADEKON başvuruları yüklenemedi.");
    }
  },

  async listMembers() {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await listKadekonMembersFromFirestore();
    } catch (error) {
      throw wrap(error, "KADEKON üyeleri yüklenemedi.");
    }
  },

  async listQrCodes() {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await listKadekonQrCodesFromFirestore();
    } catch (error) {
      throw wrap(error, "KADEKON QR kodları yüklenemedi.");
    }
  },

  async approve(applicationId) {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await approveKadekonApplicationInFirestore(applicationId);
    } catch (error) {
      throw wrap(error, "Başvuru onaylanamadı.");
    }
  },

  async reject(applicationId, note) {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await rejectKadekonApplicationInFirestore(applicationId, note);
    } catch (error) {
      throw wrap(error, "Başvuru reddedilemedi.");
    }
  },

  async setMemberStatus(memberId, status) {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await setKadekonMemberStatusInFirestore(memberId, status);
    } catch (error) {
      throw wrap(error, "Üye durumu güncellenemedi.");
    }
  },

  async revokeQr(qrId) {
    if (!isFirebaseConfigured) throw new Error("Firebase yapılandırılmamış.");
    try {
      return await revokeKadekonQrInFirestore(qrId);
    } catch (error) {
      throw wrap(error, "QR kod iptal edilemedi.");
    }
  },
};
